import {AttachmentType} from '@q9elements/ui-kit/common';

const SKIP_ATTACHMENTS: Partial<Record<AttachmentType, boolean>> = {
  image: true,
  datatable: true,
  text: true
};

export function shouldSkipUndoAttachment(type: AttachmentType): boolean {
  return SKIP_ATTACHMENTS[type] ?? false;
}
